import { AccountGroupIcon } from './AccountGroupIcon';

/**
 * author: GreenTurtwig
 * id 7B8F1133-B47B-46C0-AAC0-FD87F06B038D
 * name account-group
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-group.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const AccountsGroupIcon = AccountGroupIcon;
export default AccountsGroupIcon